import * as React from "react";
import { Tabs, TabContent, TabPanel, TabLink, SortTableProvider } from "soprasteria-ui-library";
import { IOrganisationTab } from "../../../../models/IOrganisation";
import { ClinicTab } from "./Clinic/ClinicTab";
import { ContractAreaTab } from "./ContractArea/ContractAreaTab";
import { RoleGroupTab } from "./RoleGroup/RoleGroupTab";

interface IProps {
    organisationId: number;
    selectedTab: IOrganisationTab | undefined;
    onTabSubmit: (message: string, tab: IOrganisationTab) => void;
}

export const OrganisationTabs: React.FC<IProps> = ({ organisationId, selectedTab, onTabSubmit }) => {
    const contractAreaTabSelected = selectedTab === undefined || selectedTab === IOrganisationTab.contractArea;
    const clinicTabSelected = selectedTab == IOrganisationTab.clinic;
    const roleGroupTabSelected = selectedTab === IOrganisationTab.roleGroup;

    return (
        <section>
            <Tabs>
                <TabLink href="contractAreas" id="contractAreaTab" text="Avtalsområden" selected={contractAreaTabSelected} />
                <TabLink href="clinics" id="clinicTab" text="Mottagningar" selected={clinicTabSelected} />
                <TabLink href="roleGroups" id="roleGroupTab" text="Rollgrupper" selected={roleGroupTabSelected} />
            </Tabs>
            <TabContent>
                <TabPanel id="contractAreas" ariaLabelledBy="contractAreaTab" selected={contractAreaTabSelected}>
                    <SortTableProvider>
                        <ContractAreaTab organisationId={organisationId} />
                    </SortTableProvider>
                </TabPanel>
                <TabPanel id="clinics" ariaLabelledBy="clinicTab" selected={clinicTabSelected}>
                    <SortTableProvider>
                        <ClinicTab organisationId={organisationId} />
                    </SortTableProvider>
                </TabPanel>
                <TabPanel id="roleGroups" ariaLabelledBy="roleGroupTab" selected={roleGroupTabSelected}>
                    <SortTableProvider>
                        <RoleGroupTab organisationId={organisationId} onRoleGroupSubmit={(message) => onTabSubmit(message, IOrganisationTab.roleGroup)} />
                    </SortTableProvider>
                </TabPanel>
            </TabContent>
        </section>
    )
}
